import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/inquiries";
const inquiryListApi = {
  inquiries(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  summary(params: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },

  inquiryTypes(): Promise<any> {
    const url = `${path}/types`;
    return api.get(url);
  },

  getInquiryDetail(id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  createInquiry(id: any, params: any): Promise<any> {
    const url = `${path}/reply/${id}`;
    return api.post(url, params);
  },

  deleteInquiry(id: any) {
    return api.delete(`${path}/${id}`);
  },

  updateInquiry(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },
};

export default inquiryListApi;
